import Vue from 'vue';
import { normalize, denormalize } from 'normalizr';
import store from '@/store';
import * as schemas from '@/schemas';

export const enhanceOrAdd = function(collection, key, object) {
    let original = collection[key];
    if (original)
        Object.assign(original, object);
    else
        Vue.set(collection, key, object);
}

export const loadEntity = function(payload, meta = {}) {
    let type = Object.keys(payload)[0];
    let schema = schemas[type];
    let entity = payload[type];
    let normalized = normalize(entity, schema);
    let ids = normalized.result;

    meta = Object.assign({}, { type, ids }, meta);

    store.commit('data/LOAD_ENTITIES', {
        ...normalized.entities,
        meta,
    });

    return ids;
}

export const loadPaginatedEntity = function(schemaName, paginatedEntity) {
    let payload = { [schemaName]: paginatedEntity.data };

    let entityMeta = paginatedEntity.meta || paginatedEntity;

    let meta = {
        paginated: true,
        currentPage: entityMeta.current_page,
        totalPages: entityMeta.last_page,
    };

    return loadEntity(payload, meta);
}

export const denormalizeFromState = function(input, schema) {
    let data = store.state.data;
    let entities = {
        amazonProducts: data.amazonProducts.byId,
        carts: data.carts.byId,
        cartItems: data.cartItems.byId,
        customers: data.customers.byId,
        customerOrigins: data.customerOrigins.byId,
        customerFiles: data.customerFiles.byId,
        inventories: data.inventories.byId,
        vendors: data.vendors.byId,
        mailMessages: data.mailMessages.byId,
    };

    return denormalize(input, schema, entities);
}
